var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarredSymbolic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1l-.002.001-.001.002-.002.001-.002.002C7.15 2.816 6.498 4.66 6.127 5.79c-1.219 0-3.226.047-5.14.295v.002l.001.002.001.002.001.001c1.46 1.362 3.014 2.551 3.975 3.253-.376 1.16-.953 3.084-1.308 4.98h.008c1.746-.969 3.358-2.078 4.322-2.775.987.716 2.639 1.859 4.333 2.783v-.002-.002-.002l.001-.002c-.381-1.96-.938-3.836-1.303-4.968.986-.717 2.583-1.935 3.985-3.26L15 6.096h-.002l-.002-.002-.001-.002c-1.983-.242-3.938-.292-5.128-.295C9.491 4.637 8.826 2.743 7.998 1z",
    fill: "#bfbfbf",
    overflow: "visible"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredSymbolic);
export default __webpack_public_path__ + "static/media/starred-symbolic.8e77a645ae47782dd60cfbb5c378c67e.svg";
export { ForwardRef as ReactComponent };